var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPower = function SvgPower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.652 6.5a.6.6 0 0 1 .849.001 9.086 9.086 0 1 1-12.892.04.6.6 0 0 1 .854.843 7.887 7.887 0 1 0 12.902 8.547 7.89 7.89 0 0 0-1.713-8.582.6.6 0 0 1 0-.849m-5.61-4.512a.6.6 0 0 1 .6.6v9.429a.6.6 0 0 1-1.2 0v-9.43a.6.6 0 0 1 .6-.599"
  })));
};
export default SvgPower;